module.exports = __webpack_public_path__ + "70cd20ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/customers/tu.png
// module id = 761
// module chunks = 2